import { useRef, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { DetailView } from './detail-view';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import useForms from 'src/api/accounts/vm-form';
import useToast from 'src/utils/toast-utils';
import { useCallbackAction } from 'src/hooks/use-actions';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const myId = useMemo(() => item.id || 0);

  const { updateAccount, deleteAccount, blockAccount, unlockAccount } = useForms();
  const { toastSuccess, toastError } = useToast();
  
  const apiUpdate = (values) => useCallbackAction(updateAccount, values, (result) => {
    toastSuccess(`Đã sửa ${result}`, {action: 'back'});
  }, toastError);
  const apiDelete = (values) => useCallbackAction(deleteAccount, values, 
      (result) => { 
        if(result.status === 4) { 
          toastSuccess(`Đã xóa ${result.code}`, {action: 'back'});
        }
        else {
          const msg = `${result.code} đã bị vô hiệu hóa`;
          toastSuccess(msg);
          result.isUnlock = false,
          result.isVerified = false;
          childRef.current?.setDataFromParent(result); 
        }
      }, toastError );
  const apiBlockAcc = (values) => useCallbackAction(blockAccount, values,
      (result) => { 
        const msg = `Đã khóa ${result.id}`;
        toastSuccess(msg);
        result.isUnlock = false,
        result.isVerified = false;
        childRef.current?.setDataFromParent(result); 
      }, toastError );
  const apiUnlockAcc = (values) => useCallbackAction(unlockAccount, values, 
      (result) => { 
        const msg = `Đã mở khóa ${result.id}`;
        toastSuccess(msg);
        result.isUnlock = false,
        result.isVerified = false;
        childRef.current?.setDataFromParent(result); 
      }, toastError);

  return (
    <PageSection title="Account" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.account)}
          subLabel={myId}
        />
        <Stack spacing={1}>
          <DetailView item={item} apiUpdate={apiUpdate} 
            ref={childRef} apiDelete={apiDelete} blockAccount={apiBlockAcc} unlockAccount={apiUnlockAcc} />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;
